export default __webpack_public_path__ + "static/media/vs code.f57bbf46.svg";